'use strict';
const angular = require('angular');

export class mailComposerPreviewComponent {
  /*@ngInject*/
  constructor() {
  }

  $onInit = function () {
    this.config = this.resolve.config;
  };

  ok() {
    this.cancel();
  }

  cancel() {
    this.dismiss({$value: 'cancel'});
  }

}

export default angular.module('conduApp.mailComposerPreviewComponent', [])
  .component('mailComposerPreviewComponent', {
    template: require('./mail-composer-preview.component.html'),
    bindings: {
      resolve: '<',
      config: '<',
      close: '&',
      dismiss: '&'
    },
    controller: mailComposerPreviewComponent
  })
  .name;



// WEBPACK FOOTER //
// ./client/components/mail-composer/preview/mail-composer-preview.component.js